"use client";
import * as React from "react";
import { Logo } from "./Logo";
import { NavigationMenu } from "./NavigationMenu";
import { ActionButtons } from "./ActionButtons";

function Header({isRegisterPage}) {
  return (
    <header
      layer-name="Header"
      className="d-flex justify-content-between align-items-center px-4 py-3 w-100 bg-white"
      style={{
        height: '85px',
        boxSizing: 'border-box'
      }}
    >
      <Logo />
      <NavigationMenu isRegisterPage={isRegisterPage} />
      <ActionButtons />
    </header>
  );
}

export default Header;
